module.exports = __webpack_public_path__ + "static/media/vk.9aa4cbbc.svg";